import { useState } from "react";
import { saveMappings } from "./kpiAssetApi";

/**
 * Save lifecycle shared by the add panels (AddAssetPanel, AddKpisToAssetPanel):
 * one saveMappings call guarded against empty input and double submits, with
 * `saving`/`saveError` state, calling onSaved() + onClose() on success.
 */
export function useSaveMappings(selectedFYId, onSaved, onClose) {
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  const save = async (mappings) => {
    if (!mappings.length || !selectedFYId || saving) return;
    setSaving(true);
    setSaveError("");
    try {
      await saveMappings(selectedFYId, mappings);
      onSaved();
      onClose();
    } catch (e) {
      console.error(e);
      setSaveError("Save failed — please try again.");
    } finally {
      setSaving(false);
    }
  };

  return { saving, saveError, save };
}
